export default "__VITE_ASSET__17972069__"